import { ReactNode } from "react";
import { Flex, Typography } from "antd";

import styles from "./info.module.css";

interface IProps {
  title: string | ReactNode;
  text: string | ReactNode;
  vertical?: boolean;
  id?: string;
  style?: React.CSSProperties;
}

export const ItemInfo = (props: IProps) => {
  const { title, text, vertical = true, id, style } = props;
  return (
    <>
      {vertical ? (
        <Flex vertical className={styles.itemBox} id={id} style={style}>
          <Typography.Text className="text-small" type="secondary">
            {title}
          </Typography.Text>
          <Typography.Text className="text-middle">{text}</Typography.Text>
        </Flex>
      ) : (
        <Flex gap="8px" justify="space-between" align="baseline" className={styles.horizontalItemBox} id={id}>
          <Typography.Text type="secondary" className={styles.labelCol}>
            {title}
          </Typography.Text>
          <Flex flex={1} justify="flex-end" className={`text-middle text-align-right ${styles.infoCol}`}>
            {text}
          </Flex>
        </Flex>
      )}
    </>
  );
};
